export default __webpack_public_path__ + "20b34ebc8cd216ef7eeaf376fa4e747c.svg";